import { getFullName } from '@src/utilities/nameHelper';
const SYSTEM_USER_ID = 0;
export const getCommentCreatedBy = (t, currentUser, comment) => {
    if (!comment)
        return '-';
    const isCurrentUser = currentUser?.id === comment.createdById;
    let commentCreatedBy = comment.createdBy ? getFullName(comment.createdBy) : '-';
    // if the current user is an employee and the comment was created by a different user and not part of the same client
    if (currentUser?.employeeId &&
        !isCurrentUser &&
        currentUser.clientId !== comment.createdBy?.clientId) {
        // Check if the comment was created by the system user (id: 0)
        if (comment.createdById === SYSTEM_USER_ID) {
            // For system user, just use their name (system user) instead of Guild Claims Processor
            commentCreatedBy = comment.createdBy ? getFullName(comment.createdBy) : '-';
        }
        else {
            commentCreatedBy = t('Guild Claims Processor');
        }
    }
    return commentCreatedBy;
};
